import { Autocomplete, TextField } from "@mui/material";
import InventoryTracking from "../../api/InventoryTracking";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useEffect, useState } from "react";

const SelectMaterial = ({ value, onUpdate, disabled, enableAdd, ...props }) => {
  const { authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [items, setItems] = useState([]);

  const getInventoryItems = async (controller) => {
    try {
      setLoading(true);
      let headers = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        headers.signal = controller.signal;
      }
      const response = await InventoryTracking.get(
        `/inventory?location=SDL`,
        headers
      );
      const data = {
        items: response.data.materials,
        pages: response.data.pages,
      };
      setItems([...data.items]);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInventoryItems();
  }, []);

  useEffect(() => {
    if (disabled) {
      setItems([]);
    } else {
      getInventoryItems();
    }
  }, [disabled]);

  if (items)
    return (
      <Autocomplete
        size="small"
        disablePortal
        inputValue={search}
        onInputChange={(event, newInputValue) => {
          setSearch(newInputValue);
        }}
        options={items}
        renderInput={(params) => (
          <TextField size="small" label="Select Material" {...params} />
        )}
        onChange={(event, value) => {
          onUpdate(value ?? null);
        }}
        getOptionLabel={(option) => {
          //    Return Searchable String for Each Option
          let label = `${
            option.description ||
            option.item_description ||
            option.item ||
            option.job_name
          } ${option.internal_code ? ` (${option.internal_code})` : ""}`;

          return label;
        }}
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => {
          // console.log("isOptionEqualToValue", option, value);
          //  The "selected" prop on renderOption depends on this
          return value.id == option.id;
        }}
        componentsProps={{
          popper: {
            modifiers: [
              {
                name: "flip",
                enabled: true,
              },
              {
                name: "preventOverflow",
                enabled: true,
              },
            ],
          },
        }}
      />
    );
};
export default SelectMaterial;
